// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["src/themes/absrio/assets/css/bootstrap53"], () => (__webpack_require__("./src/themes/absrio/components/jsComponents/vendors.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["src/themes/absrio/assets/css/bootstrap53"], () => (__webpack_require__("./src/themes/absrio/assets/vendor/bootstrap53/scss/bootstrap.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
